import { render, staticRenderFns } from "./ResolucionFormHeader.vue?vue&type=template&id=58c0f91e"
import script from "./ResolucionFormHeader.vue?vue&type=script&lang=js"
export * from "./ResolucionFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports